module.exports = __webpack_public_path__ + "img/70005.00adaa59.png";